import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  applyBilateralTradeCsv,
  checkBilateralTradeCsv,
  listBilateralTrades,
} from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service-SupplyBilateralTradeService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 相対取引 契約マスタ CSV アップロードの 2 段 API mutation hooks。
 *
 * 旧 `ImportBilateralTrades` (パース済み input 配列を渡す all-or-nothing の
 * 単発 RPC) は廃止され、共通基盤方式の 2 段 API に置換された
 * (設計 bilateral-manual-entry-mock-port §4「CSV 基盤」):
 *
 *   1. CheckBilateralTradeCsv — CSV 生バイト列を送り、行ステータス 5 種
 *      (変更なし / 新規 / 変更 / 削除 / エラー) の差分プレビューと引換券
 *      (check_token) を受け取る。永続的な副作用なし。
 *   2. ApplyBilateralTradeCsv — check_token を渡して確定する。エラー行が
 *      1 件でもあれば backend が全体を拒否する。
 */
export function useCheckBilateralTradeCsv(): InvalidatingMutationResultFor<
  typeof checkBilateralTradeCsv
> {
  // チェックは trading_contract を書き換えない (= upload_draft への退避のみ)
  // が、Apply と同じ hook 基盤に載せるため invalidate 集合を揃える。
  return useInvalidatingMutation(checkBilateralTradeCsv, [
    createConnectQueryKey({
      schema: listBilateralTrades,
      cardinality: 'finite',
    }),
  ])
}

/**
 * 取込確定 (2 段目)。onSuccess で list query を invalidate してテーブルを
 * 最新化する (useDeleteBilateralTrade と同パターン)。
 */
export function useApplyBilateralTradeCsv(): InvalidatingMutationResultFor<
  typeof applyBilateralTradeCsv
> {
  return useInvalidatingMutation(applyBilateralTradeCsv, [
    createConnectQueryKey({
      schema: listBilateralTrades,
      cardinality: 'finite',
    }),
  ])
}
